(function (app, ng) {

    app.controller("addAccountClientController", addAccountClientController);

    addAccountClientController.$inject = ["clientApi", "personApi", "$mdDialog", "advisorApi"];
    function addAccountClientController(clientApi, personApi, $mdDialog, advisorApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {},
                close: $mdDialog.cancel,
                addClient: addClient,
                searchAdvisors: searchAdvisors
            });

        var errorAlert = $mdDialog.alert({
            focusOnOpen: false,
            title: "An error saving has occured. Please try again.",
            ariaLabel: "Error alert",
            ok: "Close",
            skipHide: true
        });

        function addClient(client, $event) {
            $ctrl.ui.adding = true;
            client.PrimaryAdvisorId = $ctrl.advisor.Id;
            return clientApi.add(client)
                .then(function (response) {
                    $mdDialog.hide(response);
                }, function () {
                    $ctrl.ui.adding = false;
                    $mdDialog.show(errorAlert.targetEvent($event));
                });
        };

        function searchAdvisors(term) {
            return advisorApi.searchAdvisors(term).then(function (result) {
                ng.forEach(result,
                    function (row) {
                        row.Term = row.Person.FirstName + " " + row.Person.LastName;
                        if (row.Person.NickName != null && row.Person.NickName.length) row.Term += ` (${row.Person.NickName})`;
                    });
                return result;
            });
        }

        $ctrl.$onInit = () => {
            clientApi.getClientTypes().then(function (types) {
                $ctrl.clientTypes = types;
            });
        }
    };
})(window.app, window.angular); //jshint: ignore:line